import { Component } from '@angular/core';
import { MatLegacyColumnDef as MatColumnDef } from '@angular/material/legacy-table';

//** Simple template component for generic-report-data-table to access template columns */
@Component({
  template: '',
})
export class ReportTableColumnTemplateComponent {
  columnDef: MatColumnDef;
  constructor() {}
}
